import CrudPage from "./CrudPage";

const fields = [
  { name: "name", label: "Sponsor Name", required: true },
  { name: "logo_url", label: "Logo", type: "image", span: "full" },
  { name: "link", label: "Website Link", span: "full", placeholder: "https://..." },
];

const columns = [
  { key: "name", label: "Name" },
  { key: "link", label: "Link" },
];

export default function AdminSponsors() {
  return (
    <CrudPage
      title="Sponsors"
      endpoint="/sponsors"
      fields={fields}
      columns={columns}
      testidPrefix="sponsors"
      emptyDefaults={{ name: "", tier: "Sponsor", logo_url: "", link: "" }}
    />
  );
}
